import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Icon } from 'src/common/components/templateDetails/TemplateDetails.styled';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';
import { BASE_TEXT_PX, BLACK_FONT_COLOR, DARK_NAVY_FONT_COLOR, FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, SMALL_TEXT_PX, TITLE_FONT_COLOR } from 'src/styles/fonts/MCFontConstants';

export const SearchResultsContainer = styled.div`
    width: 95%;
    margin: 0 auto;
    height: 100%;

    ${media.mediumDevice`
       width: 96%;
    `}
    ${media.mobileDevice`
        display: flex;
        flex-direction: column;
        position: relative;
        overflow-y: scroll;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch
        width: 95%;
    `};
`;

export const SearchHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-top: 25px;
    ${media.mediumDevice`
        padding-top: 16px;
    `}
    ${media.mobileDevice`
        display: flex;   
        align-items: center;
        padding: 15px 10px;
    `}
`;

export const AnnouncementContent = styled.div`
    display: flex;
    flex-direction: column;
    //  background: #f5f5f5 0% 0% no-repeat padding-box;
    ${media.mobileDevice`
    display:flex;
    flex-direction: column;
    width: unset;
    padding: 20px 16px 15px 16px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    display: block;
    margin: -1px 0 0 0;
    background: #F5F5F5;
    ${media.mobileDevice`
        padding: 35px 16px 15px 16px;
        margin: 62px 0 0 0;
        height: 100%;
    `}
`}
`;

export const DemiText = styled.div`
    color: ${DARK_NAVY_FONT_COLOR};
    font-size: 20px;
    font-family: ${FONT_FAMILY_DEMI};
    display: none;
    ${media.mobileDevice`
        justify-content: center;
        display: flex;
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')};
        margin-right:19px;
    `}
`;

export const OrderCardsContainer = styled.div`
    margin: 0;
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
    //height: calc(100% - 8rem);
    height: auto;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -4px;
    `}
`;

export const BackButtonContainer = styled.div`
    display: inline-flex;
    margin: ${({ margin }) => (margin ? margin : '0 0 0 10px')};
    width: 100%;
    ${media.mobileDevice`
    width: auto;
    `}
`;

export const BackButtonIcon = styled.img`
    margin: ${({ margin }) => (margin ? margin : '0')};
    cursor: pointer;
    ${media.mobileDevice`
        margin:1;
    `}
`;

export const BackText = styled.span`
    // margin-left: 5px;
    color: ${TITLE_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${BASE_TEXT_PX};
    cursor: pointer;
    ${media.mobileDevice`
        display: ${({ mbDisplay }) => mbDisplay && mbDisplay};
    `}
`;

export const MessageContainer = styled.div`
    color: ${DARK_NAVY_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${BASE_TEXT_PX};
    margin-top: 0.5rem;

    ${media.mobileDevice`
        padding: ${({ mbPadding }) =>
            mbPadding ? mbPadding : '10px 15px 0 6px'};
        margin-top: 0px;
    `}
`;

export const TableContainer = styled.div`
    // margin-top: 3%;
    margin-top: 15px;
`;
export const BoldText = styled.span`
    color: ${DARK_NAVY_FONT_COLOR};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${BASE_TEXT_PX};
`;

export const CloseIconContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    order: 4;
    width: 5%;
    align-items: center;
    ${media.mobileDevice`
    margin-top:-30px;
    margin-right: 0;
      `}
`;

export const CloseIcon = styled(Icon)``;
export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    ${media.mobileDevice`
        flex-direction:column;
        margin: 10px 0px 0px 0px;
        justify-content: space-between;
        // position: sticky;
        // bottom:0;
        padding-bottom:${({ padding }) =>
            ENVIRONMENTVARIABLE ? '0px' : padding ? padding : '1.125rem'} 
    `}
`;

export const SearchIconContainer = styled(CloseIconContainer)``;

export const SearchIcon = styled.img.attrs((props) => ({
    src: props.deskPath,
}))`
    width: 27px;
    height: 27px;
    display: block;
    cursor: pointer;
    ${media.mobileDevice`
    display: block;
    `}
`;

export const BoxContainer = styled.div`
    display: none;
    ${media.mobileDevice`
    display:flex;
    flex-direction:column;
    padding: 10px 27px 16px 16px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '10px'};
`}
`;

export const AnnouncementContainer = styled.div`
    height: calc(100vh - 4rem);
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
        margin-top: -3.8rem;
        height: 100%;
    `}
`;

export const AnnouncementHeaderContainer = styled.div`
    display: block;
    ${media.mobileDevice`
        position: fixed;
        width: 100%;
    `}
`;

export const HeaderContainer = styled.h2`
    display: flex;
    font-family: ${FONT_FAMILY_DEMI};
    padding: 16px 0 10px 0;
    margin: 0;
    color: ${DARK_NAVY_FONT_COLOR};

    ${media.mobileDevice`
    color: #FFFFFF;
    background: ${(props) => props.theme.calendarBackgroundColor} !important;
    padding: 0 16px 20px 16px;
`}
`;

export const StyledDate = styled.div`
    text-align: left;
    font: 14px Avenir Next World;
    font-family: ${FONT_FAMILY_DEMI};
    line-height: 22px;
    letter-spacing: 0px;
    color: ${BLACK_FONT_COLOR};
    opacity: 1;
    flex-basis: 15%;

    ${media.mobileDevice`
    flex-basis:0%;
    width: 48px;
    height: 20px;
    text-align: left;
    font:9px Avenir Next World;
    font-family: ${FONT_FAMILY_DEMI};
    line-height:20px;
    letter-spacing: -0.08px;
    color: #767676;
    opacity: 1;
`}
`;
export const Information = styled.div`
    flex-basis: 85%;
    text-align: left;
    font: 14px Avenir Next World;
    font-family: ${FONT_FAMILY_REGULAR};
    letter-spacing: 0px;
    opacity: 1;

    ${media.mobileDevice`
    flex-basis:0%;
    width: 314px;
    height: 45px;
    text-align: left;
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    letter-spacing: 0px;
    color: ${BLACK_FONT_COLOR};
    opacity: 1;
    margin-top:5px;
    & > p {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 0;
        margin-bottom: 0;
    }
`}
`;

export const MessageData = styled.div`
    font-family:  ${(props) => props.fontFamily || FONT_FAMILY_REGULAR};
    font-size: ${(props) => props.fontSize || SMALL_TEXT_PX};
    color: ${(props) => props.color || BLACK_FONT_COLOR};
    opacity: 1;
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};
    font-weight: ${(props) => props.fontWeight || null};
    text-align: ${(props) => props.textAlign || 'left'};
    word-wrap: ${(props) => (props.wordWrap ? props.wordWrap : 'normal')};
    @media (max-width: 768px) {
        padding: 0;
    }
`;



export const Header = styled.div`
    display: flex;
    position: 'absolute';
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    height: 50px;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%; padding: 10px 20px;
  box-sizing: border-box;
`;
export const Button = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 4px;
    font-family: AvenirNextWorld Regular;
    font-size: 14px;

    &:hover {
        opacity: 0.8;
    }
`;

export const DesktopView = styled.div`
    display: block;

    ${media.mobileDevice`
        display: none;
    `}
`;

export const MobileView = styled.div`
    display: none;

    ${media.mobileDevice`
        display: block;
        background-color: white;
        width: 100%;
        flex-grow: ${({ flexGrow }) => flexGrow};
        overflow-y: ${({ overFlowY }) => overFlowY};
        overflow-x: ${({ overFlowX }) => overFlowX};
        //min-height: 65vh;
    `}
`;

export const BomCardsContainer = styled.div`
    margin: 0;
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
    //height: calc(100% - 8rem);
    height: auto;
    margin-left: -10px;
    margin-right: -10px;
    margin-top: -4px;,
    `}
`;

export const RegularText = styled.div`
    color: ${(props) => (props.color ? props.color : BLACK_FONT_COLOR)};
    font-size: ${(props) => props.fontSize};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : FONT_FAMILY_REGULAR};
    margin-right: ${({ margin }) => (margin ? margin : 0)};
    line-height: ${({ lineHeight }) => lineHeight};
    font-weight: ${(props) => props.fontWeight || null};
    text-align: left; // Align text to the left
    word-wrap: ${(props) => (props.wordWrap ? props.wordWrap : 'normal')};
`;

export const Div = styled.div`
    margin: 10px 0 0 0;
    ${media.mobileDevice`
        display:none;  
    `}
`;

export const CardsContainer = styled.div`
    position: relative;
    left: 7.8%;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-bottom: 60px;
    justify-content: flex-start;
    text-align: left;
`;

export const MainContainerItems = styled.div`
    width: ${({ width }) => (width ? width : '47%')};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: ${({ padding }) => (padding ? padding : '0rem')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};

    ${media.largeDevice`
        width:${({ ldWidth }) => ldWidth && ldWidth};
        padding: ${({ ldPadding }) => (ldPadding ? ldPadding : '0rem')};
    `}

    ${media.mediumDevice`
        padding: ${({ mdPadding }) => (mdPadding ? mdPadding : '0rem')};
    `}

    ${media.smalDevice`
        padding: ${({ ipadPadding }) => (ipadPadding ? ipadPadding : '0rem')};
    `}
    ${media.mobileDevice`
        width: 100%;
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : '0rem')};     
    `}
`;
